'use strict';

var useEmailValidation = require('../../../../../../../../_virtual/useEmailValidation.cjs');
var React = require('react');
var inputValidation = require('./inputValidation.cjs');

var hasRequiredUseEmailValidation;

function requireUseEmailValidation () {
	if (hasRequiredUseEmailValidation) return useEmailValidation.__exports;
	hasRequiredUseEmailValidation = 1;

	var react = React;
	var inputValidation$1 = inputValidation.__require();

	/**
	 * A hook used to run various validations against emails.
	 * It ensures that the email contains an "@" symbol as well as a "."
	 */ const useEmailValidation$1 = (options)=>{
	    const { isDirty, required, value, label } = options;
	    const validationError = react.useMemo(()=>{
	        if (!isDirty || !inputValidation$1.isValuePresent(value)) return "";
	        if (!inputValidation$1.isEmailAtValid(value)) return `${label} must include "@"`;
	        if (!inputValidation$1.isEmailDotValid(value)) return `${label} must include "."`;
	        if (!inputValidation$1.isEmailRegexValid(value)) return `${label} is invalid`;
	        return "";
	    }, [
	        isDirty,
	        required,
	        value
	    ]);
	    return {
	        validationError
	    };
	};

	useEmailValidation.__exports.useEmailValidation = useEmailValidation$1;
	
	return useEmailValidation.__exports;
}

exports.__require = requireUseEmailValidation;
//# sourceMappingURL=useEmailValidation.cjs.map
